/**
 * @file 延迟执行
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/delay
 */
var next = typeof window !== 'undefined' && (window.setImmediate || window.requestAnimationFrame) || setTimeout;

/**
  * 延迟执行函数
  *
  * @function delay
  * @param {Function} fn 要延迟执行的函数
  * @return {Function} 返回一个包装过的延迟执行的函数
  */
export default (function (fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return next(function () {
      return fn.apply(void 0, args);
    });
  };
});